import * as types from './_actionTypes';

const initialState = {
  quizTemplates: [],
  myQuizzes: [],
  loading: false,
  creating: false,
  error: null
};

const smeQuizCreationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_QUIZ_TEMPLATES_REQUEST:
    case types.FETCH_MY_QUIZZES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_QUIZ_TEMPLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        quizTemplates: action.payload,
        error: null
      };
    
    case types.FETCH_MY_QUIZZES_SUCCESS:
      return {
        ...state,
        loading: false,
        myQuizzes: action.payload,
        error: null
      };
    
    case types.FETCH_QUIZ_TEMPLATES_FAILURE:
    case types.FETCH_MY_QUIZZES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case types.CREATE_QUIZ_REQUEST:
    case types.UPDATE_QUIZ_REQUEST:
      return {
        ...state,
        creating: true,
        error: null
      };
    
    case types.CREATE_QUIZ_SUCCESS:
      return {
        ...state,
        creating: false,
        myQuizzes: [action.payload, ...state.myQuizzes],
        error: null
      };
    
    case types.UPDATE_QUIZ_SUCCESS:
      return {
        ...state,
        creating: false,
        myQuizzes: state.myQuizzes.map(quiz =>
          quiz.id === action.payload.id ? action.payload : quiz
        ),
        error: null
      };
    
    case types.DELETE_QUIZ_SUCCESS:
      return {
        ...state,
        myQuizzes: state.myQuizzes.filter(quiz => quiz.id !== action.payload)
      };
    
    case types.CREATE_QUIZ_FAILURE:
    case types.UPDATE_QUIZ_FAILURE:
    case types.DELETE_QUIZ_FAILURE:
      return {
        ...state,
        creating: false,
        error: action.payload
      };
    
    default:
      return state;
  }
};

export default smeQuizCreationReducer;